import Vue from "vue";

import api from "../api";

const baixarCartaNegativa = payload => {
  return Vue.api.get(api.cartaNegativa(payload));
};

const buscaProtocoloDetalhes = payload => {
  return Vue.api.get(api.protocoloDetalhe(payload));
};

const buscaProtocoloGrid = payload => {
  return Vue.api.get(api.protocoloGrid(payload));
};

const listaStatusProtocolo = () => {
  return Vue.api.get(api.statusProtocolo()).then(({ data }) => data);
};

const listaTiposSolicitacao = () => {
  return Vue.api.get(api.tiposSolicitacao()).then(({ data }) => data);
};

export {
  baixarCartaNegativa,
  buscaProtocoloDetalhes,
  buscaProtocoloGrid,
  listaStatusProtocolo,
  listaTiposSolicitacao
};
